export function stripHtmlTags(input: string): string {
  return input.replace(/<[^>]*>/g, "");
}

const DEFAULT_LINE_BANNER_HIDDEN_GROUPS: readonly string[] = [
  "法人グループ8",
  "subscriber13",
  "subscriber10",
  "subscriber11",
  "subscriber12",
];

type LineBannerVisibilityParams = {
  lang: string;
  group: string;
  isLineLogin?: boolean;
};

/** LINEバナーを表示できる条件を判定する */
export function isVisibleLineBanner({
  lang,
  group,
  isLineLogin = false,
}: LineBannerVisibilityParams): boolean {
  return (
    lang === "ja" &&
    !isLineLogin &&
    !DEFAULT_LINE_BANNER_HIDDEN_GROUPS.includes(group)
  );
}

const ALIGNMENT_ALERT_GROUPS: readonly string[] = [
  "subscriber06",
  "subscriber07",
  "subscriber19",
];

/** W連携周りの複数所属先ID注意表示を出す対象グループか */
export function isVisibleAlignmentAlert(group: string): boolean {
  return ALIGNMENT_ALERT_GROUPS.includes(group);
}

/** OPTIMA 予約のホテル詳細URL（/ja/hotels/）かどうか */
export function isOptimaHotelUrl(url: string): boolean {
  return url.startsWith(
    `${process.env.VUE_APP_OPTIMA_RESERVATION_URL}/ja/hotels/`
  ) || url.startsWith('https://go-haimurubushikohama.reservation.jp/ja/closedLogin');
}

/** 予約ボタンのリンクURLを返す */
export function hotelReserveLinkUrl(
  datas: { htl_id: string; stayingPlans: Array<{ buttonUrl: string }> },
  index: number,
  lang: string,
  authGroup: string,
  mghrwc: boolean
): string {
  const url = datas.stayingPlans[index].buttonUrl;
  if (authGroup === "subscriber12" && datas.htl_id === "tokyodome") {
    return lang === "en"
      ? "https://www.tokyodome-hotels.co.jp/e/stay/"
      : "https://www.tokyodome-hotels.co.jp/stay/plan/";
  }
  if (isOptimaHotelUrl(url) && mghrwc) {
    return `/to-mghrwc?redirect=${encodeURIComponent(url)}`;
  }
  return url;
}
